<div *ngFor="let panel of panels">
  <app-panel [panel]="panel" [panelElements]="panelElements"></app-panel>
</div>
